import styled from 'styled-components';

export const Label = styled.label`
  color: white;
  font-size: 14px;
  margin: 0 0 13px 0;
  text-shadow: 1px 0 1px #666;
  display: block;
`;

export const Select = styled.select`
  border: 0 none;
  background: #000;
  color: #fff;
  padding: 2px;
  font-size: 14px;
  height: 32px;
  width: 100%;
`;

export const Input = styled.input`
  color: white;
  background: #333;
  border: 1px solid ${props => props.hasError ? 'red' : '#333'};
  padding: 0 8px;
  height: 32px;
  font-size: 14px;
  margin-right: 5px;
  box-sizing: border-box;
  flex: 1;
  width: 100%;

  &:focus {
    outline: 1px solid ${props => props.outlineColor};
  }
`;

export const Textarea = styled.textarea`
  color: white;
  background: #333;
  border: 1px solid ${props => props.hasError ? 'red' : '#333'};
  padding: 0 8px;
  font-size: 14px;
  margin-right: 5px;
  box-sizing: border-box;
  flex: 1;
  width: 100%;

  &:focus {
    outline: 1px solid ${props => props.outlineColor};
  }
`;


// WEBPACK FOOTER //
// ./src/components/ui/forms.js